import { CheckCircle2, XCircle } from "lucide-react";

export interface MailboxOAuthStatus {
  google: boolean;
  microsoft: boolean;
}

export interface MailboxOAuthStatusBadgesProps {
  isAdmin: boolean;
  oauthStatus: MailboxOAuthStatus | null | undefined;
}

export function MailboxOAuthStatusBadges({
  isAdmin,
  oauthStatus,
}: MailboxOAuthStatusBadgesProps) {
  if (!isAdmin || !oauthStatus) return null;
  return (
    <div
      className="mb-4 flex flex-wrap gap-2"
      data-testid="mailbox-oauth-status-badges"
    >
      <span
        data-testid="badge-google-oauth"
        className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-1 text-xs font-medium ${
          oauthStatus.google
            ? "border-green-200 bg-green-50 text-green-700 dark:border-green-900 dark:bg-green-950/30 dark:text-green-400"
            : "border-amber-200 bg-amber-50 text-amber-700 dark:border-amber-900 dark:bg-amber-950/30 dark:text-amber-400"
        }`}
        title={
          oauthStatus.google
            ? "GOOGLE_CLIENT_ID and GOOGLE_CLIENT_SECRET are set on the server."
            : "GOOGLE_CLIENT_ID and/or GOOGLE_CLIENT_SECRET are missing on the server."
        }
      >
        {oauthStatus.google ? (
          <CheckCircle2 className="h-3.5 w-3.5" />
        ) : (
          <XCircle className="h-3.5 w-3.5" />
        )}
        {oauthStatus.google ? "Google OAuth configured" : "Google OAuth not configured"}
      </span>
      <span
        data-testid="badge-microsoft-oauth"
        className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-1 text-xs font-medium ${
          oauthStatus.microsoft
            ? "border-green-200 bg-green-50 text-green-700 dark:border-green-900 dark:bg-green-950/30 dark:text-green-400"
            : "border-amber-200 bg-amber-50 text-amber-700 dark:border-amber-900 dark:bg-amber-950/30 dark:text-amber-400"
        }`}
        title={
          oauthStatus.microsoft
            ? "MS_CLIENT_ID and MS_CLIENT_SECRET are set on the server."
            : "MS_CLIENT_ID and/or MS_CLIENT_SECRET are missing on the server."
        }
      >
        {oauthStatus.microsoft ? (
          <CheckCircle2 className="h-3.5 w-3.5" />
        ) : (
          <XCircle className="h-3.5 w-3.5" />
        )}
        {oauthStatus.microsoft
          ? "Microsoft OAuth configured"
          : "Microsoft OAuth not configured"}
      </span>
    </div>
  );
}
